import styled from "styled-components"

export interface StyledSubSectionProps {
  remove_divider: boolean
  image_position: boolean
}

export const StyledSubSection = styled.section<StyledSubSectionProps>`
  padding: 64px 0;
  width: 100%;
  margin: 0 auto;

  ${(props) =>
    !props.remove_divider &&
    `border-bottom: 1px solid ${props.theme.colors.darkGrey};`}

  :last-of-type {
    ${(props) => props.remove_divider && `padding: 64px 0 0 0;`}
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 48px 0;
  }
`

export const StyledSubSectionContainer = styled.div<StyledSubSectionProps>`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 96px;

  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    ${(props) => props.image_position && `flex-direction: row-reverse;`}
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    flex-direction: column-reverse;
    gap: 32px;
    align-items: flex-start;
  }
`
export const StyledHeroLabel = styled.p`
  color: ${(props) => props.theme.colors.darkGrey};
  text-transform: uppercase;
  margin: 0;
  font-size: 22px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    line-height: 20px;
  }
`

export const StyledSubSectionHeading = styled.h2`
  font-family: ${(props) => props.theme.fonts.circularBook};
  font-size: 64px;
  line-height: 68px;
  text-transform: uppercase;
  margin: 0 0 0 -4px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 32px;
    line-height: 36px;
    margin: 0 0 0 -2px;
  }
`

export const StyledSubSectionDescription = styled.p`
  font-size: 18px;
  line-height: 22px;
  color: ${(props) => props.theme.colors.darkGrey};
  max-width: 786px;
  padding: 24px 0;
  margin: 0;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    line-height: 20px;
    padding: 16px 0;
  }
`
export const StyledSubSectionText = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 45%;
`

export const StyledSubSectionImage = styled.div`
  min-width: 45%;
`

export const StyledSubSectionButton = styled.div``
